import { createSlice } from "@reduxjs/toolkit";
import {
    fetchCountriesThunk,
    fetchDistrictsThunk,
    fetchDivisionsThunk,
    fetchTownshipsThunk
} from "./locationThunk";

const initialState = {
    countries: {
        data: [],
        loading: false,
        error: null
    },
    divisions: {
        data: [],
        loading: false,
        error: null
    },
    districts: {
        data: [],
        loading: false,
        error: null
    },
    townships: {
        data: [],
        loading: false,
        error: null
    },
    selectedCountryId: null,
    selectedDivisionId: null,
    selectedDistrictId: null,
    selectedTownshipId: null
};

const locationSlice = createSlice({
    name: "location",
    initialState,
    reducers: {
        hydrateCountries: (state, action) => {
            state.countries.data = action.payload;
        },
        setSelectedCountry: (state, action) => {
            state.selectedCountryId = action.payload;
            state.selectedDivisionId = null;
            state.selectedDistrictId = null;
            state.selectedTownshipId = null;
            state.divisions.data = [];
            state.districts.data = [];
            state.townships.data = [];
        },
        setSelectedDivision: (state, action) => {
            state.selectedDivisionId = action.payload;
            state.selectedDistrictId = null;
            state.selectedTownshipId = null;
            state.districts.data = [];
            state.townships.data = [];
        },
        setSelectedDistrict: (state, action) => {
            state.selectedDistrictId = action.payload;
            state.selectedTownshipId = null;
        },
        setSelectedTownship: (state, action) => {
            state.selectedTownshipId = action.payload;
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(fetchCountriesThunk.pending, (state) => {
                state.countries.loading = true;
                state.countries.error = null;
            })
            .addCase(fetchCountriesThunk.fulfilled, (state, action) => {
                state.countries.loading = false;
                state.countries.data = action.payload;
            })
            .addCase(fetchCountriesThunk.rejected, (state, action) => {
                state.countries.loading = false;
                state.countries.error = action.payload;
            });

        // Divisions
        builder
            .addCase(fetchDivisionsThunk.pending, (state) => {
                state.divisions.loading = true;
                state.divisions.error = null;
            })
            .addCase(fetchDivisionsThunk.fulfilled, (state, action) => {
                state.divisions.loading = false;
                state.divisions.data = action.payload;
            })
            .addCase(fetchDivisionsThunk.rejected, (state, action) => {
                state.divisions.loading = false;
                state.divisions.error = action.payload;
            });

        // Districts
        builder
            .addCase(fetchDistrictsThunk.pending, (state) => {
                state.districts.loading = true;
                state.districts.error = null;
            })
            .addCase(fetchDistrictsThunk.fulfilled, (state, action) => {
                state.districts.loading = false;
                state.districts.data = action.payload;
            })
            .addCase(fetchDistrictsThunk.rejected, (state, action) => {
                state.districts.loading = false;
                state.districts.error = action.payload;
            });

        // Townships
        builder
            .addCase(fetchTownshipsThunk.pending, (state) => {
                state.townships.loading = true;
                state.townships.error = null;
            })
            .addCase(fetchTownshipsThunk.fulfilled, (state, action) => {
                state.townships.loading = false;
                state.townships.data = action.payload;
            })
            .addCase(fetchTownshipsThunk.rejected, (state, action) => {
                state.townships.loading = false;
                state.townships.error = action.payload;
            });
    }
});

export const {
    hydrateCountries,
    setSelectedCountry,
    setSelectedDivision,
    setSelectedDistrict,
    setSelectedTownship
} = locationSlice.actions;

export default locationSlice.reducer;
